// Filename: collections/activitys
define('collections/calendar/session/custom-animations',[
    'underscore',
    'backbone',
    'mustache',
    'moment',
    'utils',
    'services/api',
    'services/user',
    // parent
    'src/plugins/infinite-collection',
    // models
    'models/calendar/session/animation'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // src
    API,
    User,
    // parent
    InfiniteCollection,
    // model
    MAnimation
) {

    var CCustomAnimations = InfiniteCollection.extend({
        model: MAnimation,
        comparator: 'name',

        queryParams: {
            tags: function() {
                if (_.isEmpty(this.tags)) {
                    return null;
                }
                return this.tags.join();
            },
            skip: 0,
        },

        parse: function(data, opt) {
          this.apiSearchText = data.apiSearchText;
          return CCustomAnimations.__super__.parse.call(this, data, opt);
        },

        state: {
            pageSize: 500
        },

        url: function() {
            var url = API.url("exercises/?customExercises=true");
            if (!_.isEmpty(this.searchText))
                url = url + "&searchText=" + this.searchText;

            if (this.options.noRename) {
                url = url + "&noRename=true";
            }

            return url;
        },

        initialize: function(models, opt) {
            opt = opt || {};
            this.options = opt;
            this.resetFilter();
            this.listenTo(this, 'sync', this.onSync);
        },

        onSync: function(collection) {

        },

        setFilter: function(tags) {
            this.tags = tags;
            return this;
        },

        setSearchTextFilter: function(searchText) {
            this.searchText = searchText;
            return this;
        },

        resetFilter: function() {
            this.setFilter();
            this.searchText = "";
            return this;
        },

        getFilter: function() {
           return null;
        }
    });

    return CCustomAnimations;
});

